import {ID} from '../../../../../../_metronic/helpers'
import {UserModel} from '../../../../auth'
import {create, del, get, list, update} from './StockCategoryHelpers.amplify'
import {StockCategory, StockCategoryQueryResponse} from './_models'

const getStockCategories = async (query: string, currentUser?: UserModel, pageParam?: any): Promise<StockCategoryQueryResponse> => {
  if (currentUser) {
    if (pageParam) {
      query += `&last_evaluated_key_pk=${encodeURIComponent(pageParam.pk)}&last_evaluated_key_sk=${encodeURIComponent(pageParam.sk)}&last_evaluated_key_gsi1pk=${encodeURIComponent(pageParam.gsi1pk)}&last_evaluated_key_gsi1sk=${encodeURIComponent(pageParam.gsi1sk)}`
    }

    return list(currentUser, query)
  }

  return Promise.reject(new Error('Current user is null'))
}

const getStockCategoryById = (id: ID, currentUser: UserModel | undefined): Promise<StockCategory | undefined> => {
  if (currentUser && id) {
    return get(id.toString(), currentUser).then((result) => result.data)
  }

  return Promise.reject(new Error('Current user is null'))
}

const createStockCategory = (currentUser: UserModel | undefined, category: StockCategory): Promise<StockCategory | undefined> => {
  if (currentUser) {
    return create(currentUser, category).then((result) => result.data)
  }

  return Promise.reject(new Error('Current user is null'))
}

const updateStockCategory = (currentUser: UserModel | undefined, category: StockCategory): Promise<StockCategory | undefined> => {
  if (currentUser) {
    return update(currentUser, category).then((result) => result.data)
  }

  return Promise.reject(new Error('Current user is null'))
}

const deleteStockCategory = (currentUser: UserModel | undefined, id: ID): Promise<void> => {
  if (currentUser && id) {
    return del(currentUser, id.toString())
  }

  return Promise.reject(new Error('Current user is null'))
}

export {getStockCategories, getStockCategoryById, createStockCategory, updateStockCategory, deleteStockCategory}
